import { useState } from 'react'
import { ReactSVG } from 'react-svg'
import clsx from 'clsx'

interface Props {
	id?: string
	name?: string
	className?: string
	placeholder?: string
	autoComplete?: string
	onChange?: any
	onBlur?: any
	value?: any
}

export function PasswordMaskField({ value, onChange, onBlur, ...props }: Props) {
	const [type, setType] = useState('password')

	const toggleType = () => {
		if (type === 'password') {
			setType('text')
		} else {
			setType('password')
		}
	}
	return (
		<div className="relative">
			<input type={type} value={value} onChange={onChange} onBlur={onBlur} {...props} />
			<button type="button" tabIndex={-1} className="absolute top-1/2 right-4 -mt-3" onClick={toggleType}>
				<ReactSVG className={clsx({ hidden: type === 'password' })} src="/images/auth/icon-eye-slash.svg" />
				<ReactSVG className={clsx({ hidden: type === 'text' })} src="/images/auth/icon-eye.svg" />
			</button>
		</div>
	)
}
